const isProd = process.env.REACT_APP_NODE_ENV === 'production';

const logger = {
	log: (...args) => {
		if (!isProd) console.log(...args);
	},
	info: (...args) => {
		if (!isProd) console.info(...args);
	},
	warn: (...args) => {
		if (!isProd) console.warn(...args);
	},
	error: (...args) => {
		// Always log errors, and optionally send to backend
		console.error(...args);

		if (isProd) {
			fetch(`${process.env.REACT_APP_BASE_API}/api/v1/logs/log-client-error`, {
				method: 'POST',
				headers: { 'Content-Type': 'application/json' },
				body: JSON.stringify({ message: args.join(' '), time: new Date() }),
			}).catch(() => {});
		}
	},
};

export default logger;
